import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { updateUserStatusSuccess, updateUserStatusFailure } from "../../Action/auth/updateUserStatus";
import { UPDATE_USER_STATUS } from "../../Action/actionTypes";

function* updateUserStatusRequest(action) {
  try {


    const { id, status } = action.payload;
   
    const { data } = yield notifyPromise(API.put(`/user-status?id=${id}&status=${status}`));
      if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }
    if (data?.meta?.code === 200) {
      yield put(updateUserStatusSuccess(data?.data));
    } else {
      yield put(updateUserStatusFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(updateUserStatusFailure());
  }
}

export function* watchUpdateUserStatus() {
  yield takeEvery(UPDATE_USER_STATUS, updateUserStatusRequest);
}

export default function* rootSaga() {
  yield all([watchUpdateUserStatus()]);
}
